import * as agZoneTHEME from "./subpage_agZone/local-agz.js";
import * as yesterYearTHEME from "./subpage_yesterYear/local-yesterYear.js";
import * as southFloridaTHEME from "./subpage_southFlorida/local-southFlorida.js";
import * as fNightsTheme from "./subpage_fNights/local-fNights.js";
import * as utils from "./utils/utils.js";
import customNav from "./utils/customNav.js";

// ---------------------------------

// AG ZONE THEME CONTROLLER
function themeController(sparkThemeConfig) {
  // ------------
  // Running subpages cleanup on homepage
  if ($("body").hasClass("homepage")) {
    utils.storage.setItem("subPage", false);
    utils.storage.setItem("subpageName", "");
  } else {
    // ------------
    // Control for subclases under saffire inner pages
    utils.addSubThemeToSaffirePages();
    // ------------
    // Running code for render subpages
    agZoneTHEME.agZoneTheme(sparkThemeConfig);
    yesterYearTHEME.yesterTheme(sparkThemeConfig);
    southFloridaTHEME.southFloridaTHEME(sparkThemeConfig);
    fNightsTheme.fNightsTheme(sparkThemeConfig);
  }

  customNav(sparkThemeConfig[0]);
  customNav(sparkThemeConfig[1]);
  customNav(sparkThemeConfig[2]);
  customNav(sparkThemeConfig[3]);

  if (
    !utils.validateEntireSubpageTheme(sparkThemeConfig[0].baseThemeClass) &&
    !utils.validateEntireSubpageTheme(sparkThemeConfig[1].baseThemeClass) &&
    !utils.validateEntireSubpageTheme(sparkThemeConfig[2].baseThemeClass) &&
    !utils.validateEntireSubpageTheme(sparkThemeConfig[3].baseThemeClass)
  ) {
    $(".header .agz-header-content").remove();
    $(".header .southFlorida-header-content").remove();
    $(".header .yester-year-content").remove();
    $(".header .fNight-header-content").remove();

    $(".footer .yesteryear-footer").remove();
    $(".footer .southFlorida-footer").remove();
    $(".footer .ag-zone-footer").remove();
    $(".footer .fNights-footer").remove();
  }

  const $topLinks = $("#static-top-links");
  $topLinks.find(".item-main").attr("href", "/");
  $topLinks.find(".item-agz").attr("href", sparkThemeConfig[0].navItemUrl);
  $topLinks.find(".item-yy").attr("href", sparkThemeConfig[1].navItemUrl);
  $topLinks.find(".item-sf").attr("href", sparkThemeConfig[2].navItemUrl);

  setTimeout(() => {
    $(body).css("opacity", "1");
  }, 500);
}
export { themeController };
